import { Component, OnInit } from '@angular/core';
import { TaskDataService } from '../../shared/services/task-data.service';
import { IPreProcessedGeneratedTasksModel, PreProcessedGeneratedTasksModel } from '../../modules/tasks/model/types';
import { LoggingService } from '../../framework/logging/logging.service';
import { StaticDataService } from '../../shared/services/static-data.service';
import { ProfileDataService } from '../../shared/services/profile-data.service';
import validationEngine from 'devextreme/ui/validation_engine';
import { DxValidationGroupTypes } from 'devextreme-angular/ui/validation-group';
import { mapGeneratedTask } from '../../shared/controllers/generatedtaskscontroller';
import { SeverityLevel } from '../../framework/logging/severity-level.model';
import { LoanDataService } from '../../shared/services/loan-data.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-generate-tasks',
  templateUrl: './generate-tasks.component.html',
  styleUrls: ['./generate-tasks.component.css']
})
export class GenerateTasksComponent implements OnInit {

  isLoading: boolean;
  referenceTypes: any[];
  templateYesNo: Array<{id: boolean, name: string}>;
  generatedTasksData: IPreProcessedGeneratedTasksModel = new PreProcessedGeneratedTasksModel();
  rollConventions: any[];
  frequencies: any[];
  tenors: any[];
  businessDayCalendars: any[];
  allUsers: any[];
  approverGroups: any[];
  teams: any[];
  taskTemplates: any[];
  allowEditing: boolean = false;
  allowAdding: boolean = false;
  editAction: any = "click"
  isGenerateTaskButtonEnabled: boolean = this.generatedTasksData.tasks.length > 0 ? false : true;
  references: any[];
  referencesHeaderText: string;
  referencesValidationMessage: string;

  onReferenceTypeChanged(e: any){
    let reference = e.value;

    switch(reference)
    {
      case "Deal":
        {
          this.loanDataService.getAllDeals(1, 500000).subscribe((data) =>{
            this.references = data[1];
          }
        ,(error) => {this.loggingService.logError(error, SeverityLevel.Error)});

        break;
        }
        default:
          {
            break;
          }
    }

    this.referencesHeaderText = reference;
    this.referencesValidationMessage = `${reference} is required`;
  }

  onTemplateChanged(e: any)
  {
      if(e.value)
      {
        this.generatedTasksData.useTemplate = true;

        this.taskDataService.getDefaultTasksForTemplate(this.generatedTasksData.taskTemplateId).subscribe((data) =>{
          this.generatedTasksData.tasks = data[1].tasks;
        },
      (error) => { this.loggingService.logError(error, SeverityLevel.Error)});
      }
  }
  onValidateTemplate(e: any)
  {
    if(e.value == true && this.generatedTasksData.taskTemplateId )
      {
        this.allowEditing = true;
        this.allowAdding = false;
        return true;
      }
    else if (e.value == false && this.generatedTasksData.taskTemplateId)
      {
        this.generatedTasksData.taskTemplateId = null;
        this.generatedTasksData.tasks = [];
        this.allowEditing = true;
        this.allowAdding = true;
        return true;
      }
    else if (e.value == false && !this.generatedTasksData.taskTemplateId)
      {
        this.allowEditing = true;
        this.allowAdding = true;
        return true;
      }

    return false;

  
  }

  onValidateCycles(e: any)
  {
    if(e.value == 0)
    {
      e.value = null;
    }

    if((e.value != null && this.generatedTasksData.untilDate == null) ||
      (e.value == null && this.generatedTasksData.untilDate != null))
      {
        return true;
      }

    return false;
  }

  generateTasks(params) {
     let validationResult = validationEngine.validateGroup("formGroup");

     if(validationResult.isValid)
     {
        let x = mapGeneratedTask(this.generatedTasksData);

        this.taskDataService.getGeneratedTasks([x]).subscribe((data) => {
          let y = data;
          this.allowAdding = false;
          this.allowEditing = true;

        },(error) => { this.loggingService.logError(error, SeverityLevel.Error)});
     }
        
  }

  constructor(private taskDataService: TaskDataService, private staticDataService: StaticDataService, private loggingService: LoggingService,
    private profileDataService: ProfileDataService, private loanDataService: LoanDataService) {
      this.onValidateCycles = this.onValidateCycles.bind(this);
      this.onValidateTemplate = this.onValidateTemplate.bind(this);
      this.onTemplateChanged = this.onTemplateChanged.bind(this);
      this.onReferenceTypeChanged = this.onReferenceTypeChanged.bind(this);
    }

  async ngOnInit() {

    try{
        const referenceTypeData = await lastValueFrom(this.taskDataService.getStaticData("referenceType"));
        this.referenceTypes = referenceTypeData[1];

        const taskTemplateData = await lastValueFrom(this.taskDataService.getTaskTemplates(false));
        this.taskTemplates = taskTemplateData[1];

        const tenorData = await lastValueFrom(this.staticDataService.getStaticData("tenor"));
        this.tenors = tenorData[1];

        const rollConventionData = await lastValueFrom(this.staticDataService.getStaticData("dateRollConvention"));
        this.rollConventions = rollConventionData[1];

        const businessCalendarData = await lastValueFrom(this.staticDataService.getActiveBusinessDayCalendars());
        this.businessDayCalendars = businessCalendarData[1].results;

        const userData = await lastValueFrom(this.profileDataService.getAllUsers(false));
        this.allUsers = userData[1];
        
        const teamData = await lastValueFrom(this.profileDataService.getTeams());
        this.teams = teamData[1];

        const approverData = await lastValueFrom(this.profileDataService.getApproverGroups());
        this.approverGroups = approverData[1];
    }
    catch(error: any)
    {
      this.loggingService.logError(error, SeverityLevel.Error); 
    }
    
    this.templateYesNo = [{id:true, name: "Yes"}, {id:false, name:"No"}];
  
     this.frequencies = this.staticDataService.getTaskFrequencies();
      
  }

}
